import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_ALIGN,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
} from '@gcloud-npm/next12.components.text-info';
import CustomSlider from '@components/CustomSlider';
import { SendSondaComponentNotShown } from '@/utils/functions';
import { useDispatch } from 'react-redux';
import styles from './styles';

const ModuloVideos = (props) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!props) {
      const componentName = 'ModuloVideos';
      SendSondaComponentNotShown(componentName, dispatch);
      return null;
    }
  }, []);

  const { listVideos, settings } = props;
  return (
    <>
      <div className="moduloVideos container">
        <CustomSlider settings={settings}>
          {listVideos &&
            listVideos.map((video, index) => {
              return (
                <div className="sectionTestimonials" key={index}>
                  <div className="customVideo">
                    <iframe
                      className="iframe-video"
                      src={video.urlVideo}
                      title="YouTube testimonios"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    />
                  </div>
                  <TextInfo
                    text={video.title}
                    kind={TEXT_INFO_KIND.HEADING}
                    level={TEXT_INFO_HEADING_LEVEL.H3}
                    align={TEXT_INFO_ALIGN.LEFT}
                    color={TEXT_INFO_COLOR.GREY_6}
                    size={TEXT_INFO_SIZE.TITLE5}
                    fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                    className="title"
                  />
                  <TextInfo
                    text={video.nameUser}
                    kind={TEXT_INFO_KIND.SPAN}
                    align={TEXT_INFO_ALIGN.LEFT}
                    color={TEXT_INFO_COLOR.GREY_4}
                    size={TEXT_INFO_SIZE.TITLE7}
                    fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                    className="nameUser"
                  />
                </div>
              );
            })}
        </CustomSlider>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ModuloVideos;

ModuloVideos.propTypes = {
  listVideos: PropTypes.array,
};
ModuloVideos.defaultProps = {
  listVideos: [],
};
